import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";
export default function BankDetail({ isTransactionVisible, toggleTransactionVisibility, bankTransferDetail }) {
  return (
    <div className="col-md-12">
      <div className="transferInstructionHeader" onClick={toggleTransactionVisibility}                                >
        <div className="transferInstruction">
          <img src="assets/img/transferInfo.svg" alt="info" />
          <p className="m-0">Transfer Instructions</p>
        </div>
        <div style={{ cursor: "pointer" }}>
          {isTransactionVisible ? (
            <img src="assets/img/arrowUp.svg" alt="Icon" />
          ) : (
            <img src="assets/img/arrowDown.svg" alt="Icon" />
          )}
        </div>
      </div>
      <div className={`userDetailsTransaction ${isTransactionVisible ? "" : "hidden"}`}>
        <div
          className="serDetailsTransactionSection"
          style={{ paddingRight: "18px" }}
        >
          <div className="accountholderDetailsCopy">
            <div className="accountholderDetails">
              <p className="m-0">Bank name</p>
              <h5 className="m-0">
                {bankTransferDetail?.bankAccountName || "-"}
              </h5>
            </div>
            <CopyToClipboard
              text={bankTransferDetail?.bankAccountName}
            >
              <img
                className="copyText"
                onClick={() => toast.success("Copied!")}
                src="assets/img/copyText.svg"
                alt=""
              />
            </CopyToClipboard>
          </div>
          <hr
            className="dootedHr"
            style={{ marginTop: "12px", marginBottom: "12px" }}
          />
          <div className="accountholderDetailsCopy">
            <div className="accountholderDetails">
              <p className="m-0">Bank account number</p>
              <h5 className="m-0">
                {bankTransferDetail?.bankAccountNumber || "-"}
              </h5>
            </div>
            <CopyToClipboard
              text={bankTransferDetail?.bankAccountNumber}
            >
              <img
                className="copyText"
                onClick={() => toast.success("Copied!")}
                src="assets/img/copyText.svg"
                alt=""
              />
            </CopyToClipboard>
          </div>
          <hr
            className="dootedHr"
            style={{ marginTop: "12px", marginBottom: "12px" }}
          />

          <div className="accountholderDetailsCopy">
            <div className="accountholderDetails">
              <p className="m-0">Bank address</p>
              <h5 className="m-0">
                {bankTransferDetail?.bankAccountAddress || "-"}
              </h5>
            </div>
            <CopyToClipboard
              text={bankTransferDetail?.bankAccountAddress}
            >
              <img
                className="copyText"
                onClick={() => toast.success("Copied!")}
                src="assets/img/copyText.svg"
                alt=""
              />
            </CopyToClipboard>
          </div>
        </div>

        <div
          className="serDetailsTransactionSection"
          style={{ paddingLeft: "18px" }}
        >
          <div className="accountholderDetailsCopy">
            <div className="accountholderDetails">
              <p className="m-0">Beneficiary name</p>
              <h5 className="m-0">
                {bankTransferDetail?.beneficiaryName || "-"}
              </h5>
            </div>
            <CopyToClipboard
              text={bankTransferDetail?.beneficiaryName}
            >
              <img
                className="copyText"
                onClick={() => toast.success("Copied!")}
                src="assets/img/copyText.svg"
                alt=""
              />
            </CopyToClipboard>
          </div>
          <hr
            className="dootedHr"
            style={{ marginTop: "12px", marginBottom: "12px" }}
          />
          <div className="accountholderDetailsCopy">
            <div className="accountholderDetails">
              <p className="m-0">SWIFT/BIC code</p>
              <h5 className="m-0">
                {bankTransferDetail?.swiftBICCode || "-"}
              </h5>
            </div>
            <CopyToClipboard
              text={bankTransferDetail?.swiftBICCode}
            >
              <img
                className="copyText"
                onClick={() => toast.success("Copied!")}
                src="assets/img/copyText.svg"
                alt=""
              />
            </CopyToClipboard>
          </div>
          <hr
            className="dootedHr"
            style={{ marginTop: "12px", marginBottom: "12px" }}
          />
          <div className="accountholderDetailsCopy">
            <div className="accountholderDetails">
              <p className="m-0">Beneficiary address</p>
              <h5 className="m-0">
                {bankTransferDetail?.beneficiaryAddress || "-"}
              </h5>
            </div>
            <CopyToClipboard
              text={bankTransferDetail?.beneficiaryAddress}
            >
              <img
                className="copyText"
                onClick={() => toast.success("Copied!")}
                src="assets/img/copyText.svg"
                alt=""
              />
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </div>
  );
}
